import { render } from "./BgCenter.vue?vue&type=template&id=0d416109&scoped=true"
import script from "./BgCenter.vue?vue&type=script&lang=js"
export * from "./BgCenter.vue?vue&type=script&lang=js"

import "./BgCenter.vue?vue&type=style&index=0&id=0d416109&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d416109"]])

export default __exports__